document.body.classList.remove('no-js');

import Glide from '@glidejs/glide'
import './static-forms.js'

const sliderEl = document.querySelector('.glide__header');
if (sliderEl) {
    const slider = new Glide(sliderEl, {
        type: 'carousel',
        startAt: 0,
        autoplay: 5000,
        perView: 1,
        focusAt: 'center',
        gap: 0
    }).mount();
}

const urlParams = new URLSearchParams(window.location.search);
const slideId = urlParams.get('slideId');
const slideIndex = urlParams.get('slideIndex');

const galleryEl = document.querySelector('.glide__gallery')
if (galleryEl) {
    const gallery = new Glide(galleryEl, {
        type: 'slider',
        startAt: slideIndex || 0,
        perView: 1,
        focusAt: 'center',
        gap: 0
    }).mount();

    if (slideId !== null) {
        gallery.go('>>');
    }
}

import SimpleLightbox from "simplelightbox/dist/simple-lightbox.modules.js";
var galleryImages = document.querySelectorAll('.glide__slide__image');

if (galleryImages.length !== 0) {
    galleryImages.forEach(gallery => {
        var lightbox = new SimpleLightbox(gallery, { });
    });
}